// SidebarMenu.jsx
import React, { useState } from 'react';
import './SidebarMenu.scss';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../../hook';

/*  Icons  */
import { Banner, Dashboard, Leads, Location, Menu, Mesa, Order, Setting, User, Ventas } from '../Icons';
import { ExpandMore } from '@mui/icons-material';
import { Gastos } from '../Icons/gastos';
import { Contabilidad } from '../Icons/contabilidad';

export function SidebarMenu() {
  const { auth }      = useAuth();
  const { pathname }  = useLocation();

  /* ---------- 1) MENÚ PRINCIPAL ---------- */
  const menuItems = [
    { key: 'dasboard',   text: 'Dashboard',    icon: <Dashboard />, path: '/admin' },

    { key: 'comparative',   text: 'Comparative',    icon: <Ventas />, path: '/admin/comparative' },

    { key: 'ventas',   text: 'Ventas',    icon: <Ventas />, path: '/admin/ventas' },

    { key: 'gastos',   text: 'Gastos',    icon: <Gastos />, path: '/admin/gastos' },

    {
      key: 'leads',
      text: 'Leads',
      icon: <Leads />,
      submenu: [
        { text: 'Kanban',      path: '/admin/leads' },
        { text: 'Leads',       path: '/admin/leads-table' }
       
      ],
    },
    
    {
      key: 'contabilidad',
      text: 'Contabilidad',
      icon: <Contabilidad />,
      submenu: [
        { text: 'Facturas',      path: '/admin/facturas' },
        { text: 'Compras',       path: '/admin/compras' }
       
      ],
    },

    

   

    { key: 'settings', text: 'Opciones', icon: <Setting />, path: '/admin/settings' },
  ];

  if (auth.me.is_staff) {
    menuItems.push({
      key: 'users',
      text: 'Usuarios',
      icon: <User />,
      submenu: [
        { text: 'Todos',     path: '/admin/users' },
        { text: 'Permisos',  path: '/admin/permissions' },
      ],
    });
  }

  /* ---------- 2) ESTADO DE LOS SUB-MENÚS ---------- */
  const initialOpen = menuItems.reduce((acc, item) => {
    if (item.submenu) {
      acc[item.key] = item.submenu.some(sub => sub.path === pathname);
    }
    return acc;
  }, {});

  // ► Si prefieres acordeón: cambia MULTIPLE_OPEN a false
  const MULTIPLE_OPEN = false;

  const [openMenus, setOpenMenus] = useState(initialOpen);

  const toggleMenu = key => {
    setOpenMenus(prev => {
      if (MULTIPLE_OPEN) {
        return { ...prev, [key]: !prev[key] };
      }
      // acordeón
      const next = {};
      Object.keys(prev).forEach(k => { next[k] = k === key ? !prev[k] : false; });
      return next;
    });
  };

  /* ---------- 3) RENDER ---------- */
  return (
    <div className="sidebar_row">
      <div className="logo_app">
        <img src="/logo.png" alt="Logo" />
      </div>

      <div className="sidebar__menu-content">
        <div className="menu-content_top">
          <ul className="list_menu">
            {menuItems.map(item => { 
              
              return(
              <li key={item.key}>
                {item.submenu ? (
                  <>
                    <div
                      className={`menu-item row-sb middle ${
                        openMenus[item.key] ? 'current-menu' : ''
                      }`}
                      onClick={() => toggleMenu(item.key)}
                    >
                      <div className="row-cl gap10 middle">
                        <div className="icon">{item.icon}</div>
                        <span className="text">{item.text}</span>
                      </div>
                      <ExpandMore />
                    </div>

                    {openMenus[item.key] && (
                      <ul className="sub-menu">
                        {item.submenu.map((sub, i) => (
                          <li key={i}>
                            <Link
                              to={sub.path}
                              className={pathname === sub.path ? 'current-subitem' : ''}
                            >
                              {sub.text}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                ) : (
                  <Link
                    to={item.path}
                    className={pathname === item.path ? 'current-menu' : ''}
                  >
                    <div className="icon">{item.icon}</div>
                    <span className="text">{item.text}</span>
                  </Link>
                )}
              </li>
            )})}
          </ul>
        </div>
      </div>

      <div className="sidebar_notice">
            <small>Version 3.0</small>
      </div>
    </div>
  );
}
